<template>
  <div>
    <apexchart
      v-if="shiftSeries.some((v) => v > 0)"
      type="donut"
      height="460"
      :options="shiftsOpts"
      :series="shiftSeries"
    />
    <div
      v-else
      class="d-flex justify-center align-center grey--text text--lighten-1"
      style="min-height: 400px"
    >
      <span class="text-body-2">{{ $t("no_data") }}</span>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const SHIFT_COLORS = ["#1E88E5", "#43A047", "#FB8C00", "#8E24AA"];

export default {
  name: "GroupMealsShiftsChart",
  components: { apexchart: VueApexCharts },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    shiftSeries() {
      const totals = [0, 0, 0, 0];
      for (const item of this.orders) {
        const s = (item.shift || 1) - 1;
        if (s >= 0 && s < 4) totals[s] += Number(item.quantity || 0);
      }
      return totals;
    },
    shiftsOpts() {
      return {
        chart: { type: "donut", fontFamily: "Roboto, sans-serif" },
        labels: this.shiftLabels,
        colors: SHIFT_COLORS,
        legend: { position: "bottom" },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`,
          dropShadow: { enabled: false },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "60%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: this.$t("total"),
                  formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
                },
              },
            },
          },
        },
        tooltip: { y: { formatter: (val) => `${val} ${this.$t("meal_meal")}` } },
      };
    },
  },
};
</script>
